import React, {useState, useEffect} from "react";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import { NavTitle, Icon, NavItem, NavItemArea, VersionNumber } from "../styled/Sidebar.styled";
import {useVsiAppContext} from "../stores/VsiApp";
import {Tooltip} from "reactstrap";
import {
    deviceItems,
    storageItems,
    buItems,
    finOpsItems,
    virtualItems,
    virtualHostItems,
    vmItems,
    switchesItems,
    virtualClusterItems,
    virtualDatastoreItems,
    entHostItems,
    filesItems,
    cloudItems,
    hostItems,
    backupItems,
    switchItems,
    virtualVCenterItems,
    databaseServerItems,
    databaseItems,
    securityItems,
    kubernetesItems,
    kubernetesClusterItems,
    kubernetesNodeItems
} from "../utils/routes";
import {returnPathWithQuery} from "../utils/Helpers";
import {ListGroup, ListGroupItem} from "reactstrap";
import {VsiMedText} from "../styled/App.styled";
import themeStyles from "../utils/themeStyles";
import {withErrorBoundary} from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

const defaultIcon = "fa-chart-line";

function ReportIcons({report, theme, location, isSidebarOpen}) {
    const [isTooltipOpen, setTooltipOpen] = useState(false);
    const toggleTooltip = () => setTooltipOpen(!isTooltipOpen);

    const [isHovering, setIsHovering] = useState(false);

    const isActive = location.pathname.includes(report.oldPath);
    return (
        <Link to={report.path}
              style={{textDecoration: "none", color: "inherit"}}>
            <ListGroupItem className={`w-100`}
                           onMouseEnter={() => setIsHovering(true)}
                           onMouseLeave={() => setIsHovering(false)}
                           id={`nav-item-${report?.title?.replace?.(/[^a-zA-Z0-9_-]/g, '-')?.split?.(' ')?.join('-')}`}
                           style={{backgroundColor: themeStyles[theme].navItemBgActive, whiteSpace: 'nowrap'}}
                           active={location.pathname.includes(report.oldPath)}>
                <i className={`fa-${isActive || isHovering ? 'solid' : 'regular'} ${report.icon || defaultIcon} px-2`}
                   style={{color: themeStyles[theme].sideColor}}/>
                <VsiMedText color={themeStyles[theme].sideColor}>{!isSidebarOpen ? '' : report.title}</VsiMedText>
            </ListGroupItem>
            {!isSidebarOpen ? <Tooltip toggle={toggleTooltip}
                                       isOpen={isTooltipOpen}
                                       placement={"right"}
                                       target={`nav-item-${report?.title?.replace?.(/[^a-zA-Z0-9_-]/g, '-')?.split?.(' ')?.join('-')}`}>
                {report?.title}
            </Tooltip> : null}
        </Link>
    )
}

function SideNavItem({icon, title, path, items, beta}) {
    let location = useLocation();
    const { user, sidebarOpen, theme } = useVsiAppContext();
    const [activeReports, setActiveReports] = useState([]);
    const [searchParams] = useSearchParams();

    const [drilledDownTitle, setDrilledDownTitle] = useState('');
    const [isHovering, setIsHovering] = useState(false);

    const isActive = location.pathname.includes(path);

    const checkReports = (pathNameSplit) => {
        let params = [];
        let ddTitle = '';
        if (pathNameSplit.includes('reports')) {
            if (pathNameSplit.includes('storage')) {
                if (pathNameSplit.includes('device')) {
                    params = deviceItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                    ddTitle = 'Device';
                } else {
                    params = storageItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                }
            }
            if (pathNameSplit.includes('hosts')) {
                if (pathNameSplit.includes('host')) {
                    params = hostItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                    ddTitle = 'Host';
                } else {
                    params = entHostItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                }
            }
            if (pathNameSplit.includes('file-analysis')) {
                params = filesItems.map(param => {
                    return {
                        ...param,
                        oldPath: param.path,
                        path: returnPathWithQuery(param.path, param.context, searchParams),
                    }
                });
            }
            if (pathNameSplit.includes('business-unit')) {
                // checkParam(params, buItems);
                params = buItems.map(param => {
                    return {
                        ...param,
                        oldPath: param.path,
                        path: returnPathWithQuery(param.path, param.context, searchParams),
                    }
                });
            }
            if (pathNameSplit.includes('finops')) {
                params = finOpsItems.map(param => {
                    return {
                        ...param,
                        oldPath: param.path,
                        path: returnPathWithQuery(param.path, param.context, searchParams),
                    }
                });
            }
            if (pathNameSplit.includes('cloud')) {
                params = cloudItems.map(param => {
                    return {
                        ...param,
                        oldPath: param.path,
                        path: returnPathWithQuery(param.path, param.context, searchParams),
                    }
                });
            }
            if (pathNameSplit.includes('virtual')) {
                if (pathNameSplit.includes('vcenter')) {
                    params = virtualVCenterItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });

                    ddTitle = 'VCenter';
                } else if (pathNameSplit.includes('host')) {
                    params = virtualHostItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });

                    ddTitle = 'ESX Host';
                } else if (pathNameSplit.includes('cluster')) {
                    params = virtualClusterItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });

                    ddTitle = 'Cluster';
                } else if (pathNameSplit.includes('datastore')) {
                    params = virtualDatastoreItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });

                    ddTitle = 'Datastore';
                } else if (pathNameSplit.includes('vm')) {
                    params = vmItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                    ddTitle = 'VM';
                } else {
                    params = virtualItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                }
            }
            if (pathNameSplit.includes('backup')) {
                params = backupItems.map(param => {
                    return {
                        ...param,
                        oldPath: param.path,
                        path: returnPathWithQuery(param.path, param.context, searchParams),
                    }
                });
            }
            if (pathNameSplit.includes('san-switch')) {
                if (pathNameSplit.includes('switch')) {
                    params = switchItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                    ddTitle = 'Switch';
                } else {
                    params = switchesItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                }
            }
            if (pathNameSplit.includes('database')) {
                if (pathNameSplit.includes('server')) {
                    params = databaseServerItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                    ddTitle = 'Server';
                } else {
                    params = databaseItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                }
            }
            if (pathNameSplit.includes('security')) {
                params = securityItems.map(param => {
                    return {
                        ...param,
                        oldPath: param.path,
                        path: returnPathWithQuery(param.path, param.context, searchParams),
                    }
                });
            }
            if (pathNameSplit.includes('kubernetes')) {
                if (pathNameSplit.includes('cluster')) {
                    params = kubernetesClusterItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });

                    ddTitle = 'Cluster';
                } else if (pathNameSplit.includes('node')) {
                    params = kubernetesNodeItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });

                    ddTitle = 'Node';
                } else {
                    params = kubernetesItems.map(param => {
                        return {
                            ...param,
                            oldPath: param.path,
                            path: returnPathWithQuery(param.path, param.context, searchParams),
                        }
                    });
                }
            }
        }
        setDrilledDownTitle(ddTitle);
        return params;
    }

    const checkSideArea = () => {
        let pathNameSplit = location.pathname.split("/");
        let reportParams = checkReports(pathNameSplit);
        setActiveReports(reportParams);
    }

    useEffect(() => {
        checkSideArea();
    }, [location])

    return (
        <>
            <Link to={items?.[0]?.path || path}
                  style={{textDecoration: "none", color: "inherit"}}>
                <NavItemArea $active={isActive}
                             onMouseEnter={() => setIsHovering(true)}
                             onMouseLeave={() => setIsHovering(false)}
                             id={`nav-item-${title?.split?.(' ')?.join('-')}`}
                             $isNavOpen={sidebarOpen}>
                    <NavItem $active={isActive} $isNavOpen={sidebarOpen}>
                        <Icon className={`fa-${isActive || isHovering ? 'solid' : 'regular'} ${icon}`}
                              $active={isActive}
                              $isNavOpen={sidebarOpen}/>
                        <NavTitle $active={isActive} $isNavOpen={sidebarOpen}>
                            {title + ((isActive && drilledDownTitle) ? ` / ${drilledDownTitle}` : '')}
                        </NavTitle>
                        {beta && <VersionNumber className={"fst-italic"}>
                            Beta
                        </VersionNumber>}
                    </NavItem>
                </NavItemArea>
            </Link>
            {isActive ? <ListGroup>
                {activeReports.map((report, index) => {
                    if (!report.roles || report.roles.includes(user.role)) {
                        return (
                            <ReportIcons report={report}
                                         key={`list-item-nav-${index}`}
                                         index={index}
                                         theme={theme}
                                         location={location}
                                         isSidebarOpen={sidebarOpen}/>
                        )
                    }
                })}
            </ListGroup> : null}
        </>
    );
}

export default withErrorBoundary(SideNavItem, GeneralErrorBoundary);
